var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyordersinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "myorders_inline_svg__bb_svg myorders_inline_svg__bb_svg--stack",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#027ac6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.513 11.747l-.814-.384a.388.388 0 00-.384 0l-4.861 2.306c-.272.135-.61.135-.882 0l-4.884-2.306a.388.388 0 00-.384 0l-.814.384a.458.458 0 000 .837l6.06 2.871c.27.136.61.136.881 0l6.06-2.871c.384-.181.384-.679.022-.837zm0-3.165l-.837-.385a.388.388 0 00-.384 0l-4.838 2.307c-.272.135-.61.135-.882 0L3.71 8.197a.388.388 0 00-.384 0l-.837.385a.458.458 0 000 .836l6.06 2.894c.27.136.61.136.881 0l6.06-2.871c.384-.181.384-.678.022-.86zM2.49 6.252l6.06 2.872c.27.136.61.136.881 0l6.06-2.871a.458.458 0 000-.837L9.43 2.545a1.006 1.006 0 00-.882 0L2.49 5.439a.44.44 0 000 .814z"
  })));
}
export default SvgMyordersinline;